/**
 * SM-2 (SuperMemo 2) — algoritmo clássico de revisão espaçada.
 *
 * Grade 0..5:
 *   0-2 → resposta errada / hesitação. Reseta repetições e interval volta a 1 dia.
 *   3   → OK com esforço. Pequeno ajuste de ease.
 *   4-5 → fácil/perfeito. Aumenta ease.
 *
 * EF mínimo 1.3 (recomendação SuperMemo).
 *
 * Refs: https://super-memory.com/english/ol/sm2.htm
 */

export interface SM2State {
  ease_factor: number; // EF, começa em 2.5
  interval_days: number; // dias até próxima revisão
  repetitions: number; // streak de acertos consecutivos
}

export interface SM2Update extends SM2State {
  due_at: string; // ISO timestamp do próximo due
  last_grade: number;
}

export function defaultState(): SM2State {
  return { ease_factor: 2.5, interval_days: 0, repetitions: 0 };
}

export function applySM2(prev: SM2State, grade: number): SM2Update {
  const safeGrade = Math.max(0, Math.min(5, Math.round(grade)));
  let { ease_factor, interval_days, repetitions } = prev;

  if (safeGrade < 3) {
    // errou / hesitou — reset
    repetitions = 0;
    interval_days = 1;
  } else {
    repetitions += 1;
    if (repetitions === 1) interval_days = 1;
    else if (repetitions === 2) interval_days = 6;
    else interval_days = Math.round(interval_days * ease_factor);
  }

  // ajuste de EF
  ease_factor = ease_factor + (0.1 - (5 - safeGrade) * (0.08 + (5 - safeGrade) * 0.02));
  ease_factor = Math.max(1.3, Number(ease_factor.toFixed(2)));

  const due_at = new Date(Date.now() + interval_days * 86400000).toISOString();

  return { ease_factor, interval_days, repetitions, due_at, last_grade: safeGrade };
}
